module.exports = __webpack_public_path__ + "static/img/banner_lantern_slide_1.dd61b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner_lantern_slide_1.jpg
// module id = PAVP
// module chunks = 0